export type LegalLang = 'pt' | 'en';

const KEY = 'sekretly_legal_lang';

/**
 * The language the legal pages open in: an explicit choice (?lang= or the last
 * switch), else the browser's language. Portuguese is the authoritative text.
 */
export function detectLegalLang(): LegalLang {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get('lang');
    if (fromUrl === 'pt' || fromUrl === 'en') return fromUrl;
    const saved = window.localStorage.getItem(KEY);
    if (saved === 'pt' || saved === 'en') return saved;
  } catch {
    // Storage or URL access can fail; fall through to the browser language.
  }
  const nav = typeof navigator !== 'undefined' ? navigator.language : '';
  return nav.toLowerCase().startsWith('pt') ? 'pt' : 'en';
}

export function rememberLegalLang(lang: LegalLang) {
  try {
    window.localStorage.setItem(KEY, lang);
  } catch {
    // Not remembering is fine.
  }
}
